import ReactDom from 'react-dom';

import { DimmerPrimitive } from './dimmer.primitive';
import type { DimmerProps } from './dimmer.types';

export const Dimmer = ({
  className,
  onClick,
  title,
  ...props
}: DimmerProps): JSX.Element => {
  return ReactDom.createPortal(
    <DimmerPrimitive
      className={className}
      onClick={onClick}
      title={title}
      {...props}
    />,
    document.body
  );
};

Dimmer.displayName = 'Dimmer';
